import { CSSObject } from '@chakra-ui/react';

export const GridLayout: CSSObject = {
  width: ['full', null, '760px'],
  borderRadius: [null, null, 'lg'],
  display: 'flex',
  minH: '100dvh',
  h: 'auto',
  alignItems: [null, null, 'center'],
  mx: 'auto',
};
